"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectProvider = void 0;
const types_1 = require("../types");
class WalletConnectProvider {
    constructor(provider, eventBus) {
        this.provider = provider;
        this.eventBus = eventBus;
    }
    on(event, handler) {
        this.eventBus.subscribe(event, handler);
    }
    off(event, handler) {
        this.eventBus.unsubscribe(event, handler);
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.provider.isInitialized()) {
                yield this.provider.init();
            }
            return true;
        });
    }
    login(token, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const topic = options === null || options === void 0 ? void 0 : options.pairingTopic;
            const methods = options === null || options === void 0 ? void 0 : options.methods;
            const { uri, approval } = yield this.provider.connect({ topic, methods });
            this.provider.login({ token, approval });
            return uri || "";
        });
    }
    logout(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const topic = options === null || options === void 0 ? void 0 : options.pairingTopic;
            return yield this.provider.logout({ topic });
        });
    }
    signTransaction(tx) {
        return this.provider.signTransaction(tx);
    }
    signTransactions(transactions) {
        return this.provider.signTransactions(transactions);
    }
    getType() {
        return types_1.AuthProviderType.WALLET_CONNECT;
    }
    getAddress() {
        return this.provider.address;
    }
    getSignature() {
        return this.provider.signature.length ? this.provider.signature : null;
    }
    getBaseProvider() {
        return this.provider;
    }
    toJson() {
        return {
            address: this.provider.address,
            authProviderType: this.getType(),
            authenticated: !!this.provider.address,
        };
    }
}
exports.WalletConnectProvider = WalletConnectProvider;
